// extracted by mini-css-extract-plugin
export default {"tagContainer":"Tag_tagContainer__nDaNR","shake":"Tag_shake__0WJxh"};